<template>
    <div class="p-2  mt-2 rounded-lg border border-1 border-gray-500 cursor-pointer hover:bg-gray-100"
    @click="val = !val"
    >
        <div class="flex items-center">
            <checkbox v-model="val" class="ml-2" />
            
            <div class="flex flex-col pl-4">
                <div class="font-bold">
                    
                    <slot name="title" />
                </div>
                <div>
                    <slot name="body" />
                </div>
            </div>

        </div>
        
    </div>
</template>


<script>

import checkbox from './checkbox.vue';

export default {
    name: 'ExampleSelectable',
    props: ['modelValue'],
    components: {
        checkbox,
    },
    emits: ['update:modelValue'],
    data: () => ({
        val: false,
    }),
    mounted() {
        this.val = !!this.modelValue;
    },  
    watch: {
        modelValue() {
            this.val = !!this.modelValue;
        },
        val() {
            this.$emit('update:modelValue', this.val);
        }
    }


};

</script>

<style lang="scss" scoped>
    .checkbox {
        height: 20px;
        width: 20px;
    }

</style>